import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const UserIconBuilder: IconBuilder = {
	icon: ({ color = '#5C6773' }) => {
		return (
			<g
				fill="none"
				fillRule="evenodd"
				id="Page-1"
				opacity="0.7"
				stroke="none"
				strokeWidth="0.5"
			>
				<path
					d="M9.89024 7.78408C10.8746 7.78408 11.6724 8.582 11.6725 9.5663C11.6725 9.92236 11.5662 10.2528 11.3863 10.5311L12.0875 11.2323C12.2241 11.3689 12.2239 11.5917 12.0875 11.7284C11.9508 11.8648 11.729 11.864 11.5924 11.7274L10.8981 11.0341C10.6112 11.2314 10.2648 11.3485 9.89024 11.3485C8.90594 11.3485 8.10802 10.5506 8.10802 9.5663C8.10806 8.58203 8.90597 7.78412 9.89024 7.78408ZM9.89024 8.48427C9.29257 8.48432 8.80826 8.96863 8.80821 9.5663C8.80821 10.164 9.29254 10.6483 9.89024 10.6483C10.488 10.6483 10.9723 10.164 10.9723 9.5663C10.9722 8.9686 10.488 8.48427 9.89024 8.48427Z"
					fill={color}
				/>
				<path
					d="M6.43221 2.18337C7.77432 2.31988 8.82185 3.45367 8.82185 4.83181L8.80818 5.10427C8.73724 5.80053 8.39578 6.41495 7.89314 6.84743C8.26807 7.01521 8.61457 7.23622 8.92537 7.49978C8.70115 7.60467 8.49721 7.74439 8.3199 7.91286C7.96386 7.64225 7.55953 7.436 7.12263 7.31228C6.82389 7.42831 6.49945 7.4939 6.15974 7.49392L5.88728 7.48025C5.64543 7.45567 5.41321 7.3982 5.1949 7.31326C3.75795 7.72076 2.66689 9.01272 2.52596 10.6004H7.85799C7.99463 10.8683 8.18137 11.1058 8.40779 11.2996H2.15974C1.96644 11.2996 1.81013 11.1433 1.81013 10.95C1.81013 9.11725 2.88248 7.53913 4.42439 6.84841C3.92224 6.41592 3.58221 5.80019 3.51131 5.10427L3.49763 4.83181C3.49763 3.36169 4.68964 2.16977 6.15974 2.1697L6.43221 2.18337ZM6.15974 2.8699C5.07624 2.86997 4.19783 3.74829 4.19783 4.83181C4.19816 5.91505 5.07645 6.79365 6.15974 6.79372C7.24304 6.79365 8.12132 5.91505 8.12166 4.83181C8.12166 3.74829 7.24325 2.86997 6.15974 2.8699Z"
					fill={color}
				/>
			</g>
		);
	},
	viewBoxHeight: 14,
	viewBoxWidth: 14,
};



export default UserIconBuilder;

